module.exports = __webpack_public_path__ + "src/assets/textures/environmet/room_texture.jpg";